import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const styles = theme => ({
    root: {
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.border}`,
        borderBottomLeftRadius: '2px',
        borderBottomRightRadius: '2px',
    },
    noDivider: {
        borderTop: 'none',
    },
});

const useStyles = makeStyles()(styles);

const PortletFooter = props => {
    const { className, noDivider, children, ...rest } = props;
    const { classes, cx } = useStyles(undefined, {
        props,
    });
    const rootClassName = cx(
        {
            [classes.root]: true,
            [classes.noDivider]: noDivider,
        },
        className
    );

    return (
        <div {...rest} className={rootClassName}>
            {children}
        </div>
    );
};

PortletFooter.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    noDivider: PropTypes.bool,
};

export default PortletFooter;
